import { render, staticRenderFns } from "./TableTask.vue?vue&type=template&id=92fa964a&scoped=true"
import script from "./TableTask.vue?vue&type=script&lang=js"
export * from "./TableTask.vue?vue&type=script&lang=js"
import style0 from "./TableTask.vue?vue&type=style&index=0&id=92fa964a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fa964a",
  null
  
)

export default component.exports